import React, { useState, useEffect, cloneElement } from 'react'
import MQTT from 'paho-mqtt'
import uuidv1 from "uuid/v1";
import { StreamingType } from '../interface-type'

const Streaming = (props: StreamingType) => {
    const [state, setstate] = useState<any | null>(null)
    useEffect(() => {
        const client = new MQTT.Client(
            `${props.clientConfig.host}`,
            props.clientConfig.port,
            `/${props.clientConfig.protocols}`,
            `clientId-${uuidv1()}`
        );

        client.onConnectionLost = (error: any) => {
            props.onConnectionLost(error);
        }
        client.onMessageArrived = (message: any) => {
            const event = { timestamp: new Date().getTime(), message }
            setstate(event);
            props.onMessageArrived(event)
        }
        client.connect({
            useSSL: props.clientConfig.ssl,
            keepAliveInterval: 15,
            onSuccess: () => {
                client.subscribe(`${props.clientConfig.topic}`)
                props.onConnectionSuccess()
            },
        });
        return () => {
            if (client.isConnected()) {
                client.disconnect()
            }
        };
    }, [])
    return (
        <div>
            {props.children && Array.isArray(props.children)
                ? props.children.map((child: any, index: number) =>
                    cloneElement(child, { key: index, event: state })
                )
                : props.children && !Array.isArray(props.children)
                    ? cloneElement(props.children, { event: state })
                    : null}
        </div>
    )
}

Streaming.defaultProps = {
    clientConfig: {
        protocols: 'ws',
        host: 'ws-01.jetstream.gmbh',
        port: 443,
        ssl: true,
        topic: '#'
    },
    onConnectionLost: () => { },
    onMessageArrived: () => { },
    onConnectionSuccess: () => { }
}

export default Streaming
